__turbopack_context__.v({
  "container": "LoginForm-module-scss-module__gUDqCG__container",
  "divider": "LoginForm-module-scss-module__gUDqCG__divider",
  "divider-label": "LoginForm-module-scss-module__gUDqCG__divider-label",
  "email-input-container": "LoginForm-module-scss-module__gUDqCG__email-input-container",
  "email-login-container": "LoginForm-module-scss-module__gUDqCG__email-login-container",
  "email-otp-login-container": "LoginForm-module-scss-module__gUDqCG__email-otp-login-container",
  "email-otp-login-text": "LoginForm-module-scss-module__gUDqCG__email-otp-login-text",
  "email-otp-pin-input": "LoginForm-module-scss-module__gUDqCG__email-otp-pin-input",
  "email-otp-pin-input-container": "LoginForm-module-scss-module__gUDqCG__email-otp-pin-input-container",
  "email-otp-pin-input-error": "LoginForm-module-scss-module__gUDqCG__email-otp-pin-input-error",
  "email-otp-resend-code-button": "LoginForm-module-scss-module__gUDqCG__email-otp-resend-code-button",
  "email-otp-resend-code-container": "LoginForm-module-scss-module__gUDqCG__email-otp-resend-code-container",
  "email-otp-resend-code-text": "LoginForm-module-scss-module__gUDqCG__email-otp-resend-code-text",
  "email-reset-password-container": "LoginForm-module-scss-module__gUDqCG__email-reset-password-container",
  "error-message-container": "LoginForm-module-scss-module__gUDqCG__error-message-container",
  "explainer": "LoginForm-module-scss-module__gUDqCG__explainer",
  "form-btns-container": "LoginForm-module-scss-module__gUDqCG__form-btns-container",
  "loader": "LoginForm-module-scss-module__gUDqCG__loader",
  "login-form": "LoginForm-module-scss-module__gUDqCG__login-form",
  "main-btn-container": "LoginForm-module-scss-module__gUDqCG__main-btn-container",
  "password-login-container": "LoginForm-module-scss-module__gUDqCG__password-login-container",
  "password-visibility-toggle": "LoginForm-module-scss-module__gUDqCG__password-visibility-toggle",
  "possible-causes": "LoginForm-module-scss-module__gUDqCG__possible-causes",
  "secondary-btn": "LoginForm-module-scss-module__gUDqCG__secondary-btn",
  "secondary-btn-container": "LoginForm-module-scss-module__gUDqCG__secondary-btn-container",
  "sent-reset-email-message": "LoginForm-module-scss-module__gUDqCG__sent-reset-email-message",
  "seperator": "LoginForm-module-scss-module__gUDqCG__seperator",
  "small-heading": "LoginForm-module-scss-module__gUDqCG__small-heading",
  "success-tick-container": "LoginForm-module-scss-module__gUDqCG__success-tick-container",
  "trouble-btns-container": "LoginForm-module-scss-module__gUDqCG__trouble-btns-container",
});
